import { queryOptions } from '@tanstack/react-query';
import { ApiError, STEP_UP_REQUIRED_CODE, type createApiClient } from '../../api/client';
import { workspaceKey } from '../../lib/workspaceQueryKey';
import type { TransferPair } from './CashFlowTransfers';

export type QuestionsResponse = { status: 'off' } | { status: 'on'; items: TransferPair[]; truncated?: boolean };

/** A plain 403 means "not available at your level"; a step-up 403 is the house step-up flow's. */
export function isQuestionsRefusal(err: unknown): boolean {
  return err instanceof ApiError && err.status === 403 && err.code !== STEP_UP_REQUIRED_CODE;
}

/**
 * The ONE declaration of `GET /cash-flow/questions`, shared by Worth a look and the Overview's
 * Needs attention row (steward-app#2596), so the two read one cache entry and one count.
 */
export function questionsQueryOptions(api: ReturnType<typeof createApiClient>, workspaceId: string | null, enabled: boolean) {
  return queryOptions({
    queryKey: workspaceKey('cash-flow-questions', workspaceId),
    queryFn: () => api.get<QuestionsResponse>('/cash-flow/questions'),
    enabled,
    retry: (failures: number, err: unknown) => failures < 2 && !isQuestionsRefusal(err),
  });
}
